"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var InputControl_styles_1 = require("./InputControl.styles");
var InputControl = function (_a) {
    var value = _a.value, onChange = _a.onChange, _b = _a.type, type = _b === void 0 ? "text" : _b, _c = _a.className, className = _c === void 0 ? "" : _c;
    var styles = (0, InputControl_styles_1.useStyles)();
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "".concat(styles.component, " ").concat(className) }, { children: (0, jsx_runtime_1.jsx)("input", { type: type, value: value, onChange: function (e) { return onChange(e.target.value); }, className: styles.input }) })));
};
exports.default = InputControl;
